import BulletinTitle from './bulletinTitle/BulletinTitle';
import React from 'react';
import BulletinList, { BulletinItem } from './bulletinList/BulletinList';

import './bulletins.scss';

const Bulletins: React.FC<{
    bulletinsDataset?: Array<BulletinItem>;
}> = ({ bulletinsDataset }) => {
    return (
        <div className={'bulletins-container'}>
            <BulletinTitle></BulletinTitle>
            <BulletinList bulletinsDataset={bulletinsDataset}></BulletinList>
        </div>
    );
};

export default Bulletins;
